import { render } from "./ElizaBot.vue?vue&type=template&id=67097d72&scoped=true"
import script from "./ElizaBot.vue?vue&type=script&lang=js"
export * from "./ElizaBot.vue?vue&type=script&lang=js"

import "./ElizaBot.vue?vue&type=style&index=0&id=67097d72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-67097d72"

export default script